export default {
  showError: false,
  message: ''
};
